require('./bootstrap');

const {SigmaChat} = require('./sigma-chat-v2');
window.SigmaChat = SigmaChat

import SigmaWaveSurfer from 'wavesurfer.js'
window.SigmaWaveSurfer = SigmaWaveSurfer

